import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function PoweredByFooter() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Small, {
      use: "help",
      children: ["Powered by ", /*#__PURE__*/_jsx("b", {
        children: "Revenue"
      })]
    }), /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-left-1",
      "data-test-id": "powered-by-help-icon",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.search.card.poweredByHelp"
      }),
      tooltipPlacement: "bottom left"
    })]
  });
}
export default /*#__PURE__*/memo(PoweredByFooter);